export default __webpack_public_path__ + "static/media/cloud-security.4dbf4637.png";